(function () {
  'use strict';
  const submissions = new WeakMap();
  const statuses = new WeakMap();

  function showStatus(form) {
    if (typeof document.createElement !== 'function' || typeof form.appendChild !== 'function') return;
    let status = statuses.get(form);
    if (!status) {
      status = document.createElement('p');
      status.className = 'body3 search-submit-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
      statuses.set(form, status);
    }
    status.textContent = 'Pretražujem…';
  }

  function clearStatus(form) {
    statuses.get(form)?.remove();
    statuses.delete(form);
  }

  function cancel(form) {
    submissions.set(form, (submissions.get(form) || 0) + 1);
    form.removeAttribute('aria-busy');
    clearStatus(form);
  }

  async function submit(form, searchConfig, completionTexts = []) {
    const input = form.querySelector('input[name="q"]');
    if (!input || !searchConfig.query) return;
    const inputValue = input.value;
    const submissionId = (submissions.get(form) || 0) + 1;
    submissions.set(form, submissionId);
    form.setAttribute('aria-busy', 'true');
    showStatus(form);
    try {
      const query = await window.WokieeSearchQuery.resolveQuery(
        searchConfig.query, searchConfig.unavailableMode, completionTexts
      );
      if (submissions.get(form) !== submissionId || input.value !== inputValue || !form.isConnected) return;
      const url = new URL(form.action || window.routes?.search_url || '/search', window.location.origin);
      const params = new URLSearchParams(new FormData(form));
      params.set('q', query);
      params.set('type', 'product');
      params.set('options[prefix]', 'none');
      window.WokieeSearchQuery.applyStockParams(params, searchConfig);
      params.delete('page');
      url.search = params.toString();
      window.location.assign(url.toString());
    } finally {
      if (submissions.get(form) === submissionId) {
        form.removeAttribute('aria-busy');
        clearStatus(form);
      }
    }
  }

  function restoreResultInput() {
    const input = document.querySelector('[data-search-results-input]');
    if (!input) return;
    const query = window.WokieeSearchQuery.parseInput(input.value).query;
    const config = window.WokieeSearchQuery.stockConfigFromParams(new URLSearchParams(window.location.search));
    input.value = config.stockMode === 'soldout' ? `%${query}%` :
      config.stockMode === 'all' ? `%${query}` : query;
  }

  document.addEventListener('DOMContentLoaded', restoreResultInput);
  window.WokieeSearchSubmit = Object.freeze({ submit, cancel, restoreResultInput });
})();
